/* PAZZADO Scroll-Logik — einmalig geladen, mehrfaches Einbinden ist abgesichert */
(function () {
  if (window.__pazzadoInit) return;
  window.__pazzadoInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    /* Versandhinweis unter dem Preis: Dawns Standardtext ("inkl. Steuern,
       Versand wird beim Checkout berechnet") schreckt ab und stimmt nicht —
       unser Versand ist gratis. Der Text kommt aus der Sprachdatei; sie ist
       riesig, deshalb wird er hier ersetzt statt dort. */
    document.querySelectorAll('.product__tax.caption').forEach(function (el) {
      el.textContent = 'Gratis Versand mit B-Post · 30 Tage Rückgaberecht';
    });

    /* Doppelte H1 vermeiden: Dawn macht die Wortmarke in der Kopfzeile auf der
       Startseite zur H1 — unser Hero hat aber schon eine. Zwei H1 verwirren
       Suchmaschinen. Die Kopfzeilen-H1 wird zur DIV, Optik bleibt identisch. */
    var kopfH1 = document.querySelector('.header h1.header__heading');
    if (kopfH1 && document.querySelector('.pz-hero h1')) {
      var ersatz = document.createElement('div');
      ersatz.className = kopfH1.className;
      while (kopfH1.firstChild) ersatz.appendChild(kopfH1.firstChild);
      kopfH1.parentNode.replaceChild(ersatz, kopfH1);
    }

    /* 2er-Set beim Seitenaufruf vorwaehlen (Wunsch Christoph, 8. August):
       Die Reihenfolge der Varianten bleibt logisch (1er, 2er, 3er), aber ohne
       ausdruecklich gewaehlte Variante in der URL wird das 2er-Set angeklickt.
       Das change-Ereignis laesst Dawn Preis, Bild und URL nachziehen. */
    if (!/[?&]variant=/.test(location.search)) {
      /* Echter Klick statt synthetischem change-Ereignis: Dawns Variantenwaehler
         reagiert nur auf die volle Klick-Kette (click -> input -> change) und
         zieht erst dann Preis, Bild und URL nach. Kleiner Aufschub, damit Dawns
         eigene Skripte sicher fertig geladen sind. */
      setTimeout(function () {
        var zweier = document.querySelector('.product-form__input input[type="radio"][value="2er-Set"]');
        if (zweier && !zweier.checked) zweier.click();
      }, 120);
    }

    /* Zahlungsleiste auf der Produktseite direkt unter den Checkout-Knopf
       schieben (Wunsch Christoph): die Sektion rendert unterhalb der
       Produktsektion und wird hier ins Kaufformular umgehaengt. */
    var badgesSektion = document.querySelector('.pz-badges');
    var kaufKnoepfe = document.querySelector('.product-form__buttons');
    if (badgesSektion && kaufKnoepfe) {
      badgesSektion.classList.add('pz-badges--inline');
      kaufKnoepfe.insertAdjacentElement('afterend', badgesSektion);
    }

    /* Aufsteigen beim Sichtbarwerden */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.pz-rise').forEach(function (el) {
      reduce ? el.classList.add('in') : io.observe(el);
    });

    /* ---- Gewebe-Linie (crease) ---- */
    var creaseSec = document.querySelector('[data-pz-crease]');
    var threads = creaseSec ? Array.prototype.slice.call(creaseSec.querySelectorAll('.pz-thread')) : [];
    var legend = creaseSec ? Array.prototype.slice.call(creaseSec.querySelectorAll('.pz-legend span')) : [];
    var N = 72, base = 80;
    var waves = threads.map(function (_, t) {
      var a = [], ph = t * 1.7, sp = 9 * (t - 2);
      for (var i = 0; i <= N; i++) {
        a.push({ off: Math.sin(i * 0.42 + ph) * 20 + Math.sin(i * 1.13 + ph) * 9 + Math.sin(i * 2.9 + ph) * 3.5, y: base + sp });
      }
      return a;
    });
    function drawCrease(p) {
      var amp = Math.pow(1 - p, 1.7);
      threads.forEach(function (el, t) {
        var pts = waves[t], d = '';
        for (var i = 0; i <= N; i++) {
          var x = i * (1000 / N);
          d += (i ? ' L' : 'M') + x.toFixed(1) + ',' + (pts[i].y + pts[i].off * amp).toFixed(2);
        }
        el.setAttribute('d', d);
      });
      legend.forEach(function (s) { s.classList.toggle('on', p >= parseFloat(s.dataset.at)); });
    }

    /* Die Faltenlinie laeuft seit dem 7. August NICHT mehr am Scrollrad, sondern in
       einer Zeitschleife, solange die Sektion im Bild ist. Grund: die frueher
       bildschirmhohe Sticky-Sektion wurde von Testlesern fuer das Seitenende gehalten.
       Ein Durchgang: 62 % glaetten, 20 % halten, 18 % zurueck auf zerknittert. */
    var creaseSichtbar = false, creaseLaeuft = false;
    var CREASE_ZYKLUS = 7;
    function creaseLoop(ts) {
      if (!creaseSichtbar) { creaseLaeuft = false; return; }
      var f = ((ts || 0) / 1000 % CREASE_ZYKLUS) / CREASE_ZYKLUS;
      var p = f < 0.62 ? f / 0.62 : (f < 0.82 ? 1 : 1 - (f - 0.82) / 0.18);
      drawCrease(p);
      requestAnimationFrame(creaseLoop);
    }
    if (creaseSec && !reduce) {
      new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          creaseSichtbar = e.isIntersecting;
          if (creaseSichtbar && !creaseLaeuft) { creaseLaeuft = true; requestAnimationFrame(creaseLoop); }
        });
      }, { threshold: 0.2 }).observe(creaseSec);
    }

    /* ---- Vorher/Nachher ---- */
    var wipe = document.querySelector('[data-pz-wipe]');
    var manual = false;
    function setWipe(pct) { if (wipe) wipe.style.setProperty('--wipe', pct.toFixed(2) + '%'); }
    if (wipe) {
      var pointerWipe = function (e) {
        var r = wipe.getBoundingClientRect();
        var x = ((e.touches ? e.touches[0].clientX : e.clientX) - r.left) / r.width;
        manual = true;
        setWipe(Math.max(0, Math.min(1, x)) * 100);
      };
      wipe.addEventListener('mousemove', pointerWipe);
      wipe.addEventListener('touchmove', pointerWipe, { passive: true });
      wipe.addEventListener('mouseleave', function () { manual = false; });
    }

    /* ---- Erklaerzeichnungen ---- */
    var diaFaser = document.getElementById('pz-dia-faser');
    var diaRing = document.getElementById('pz-dia-ring');
    function sichtFortschritt(el) {
      var r = el.getBoundingClientRect();
      var start = window.innerHeight * 0.88, ende = window.innerHeight * 0.28;
      return Math.max(0, Math.min(1, (start - r.top) / (start - ende)));
    }
    /* Die Phasen-Beschriftungen stehen als HTML unter der Zeichnung, nicht mehr im SVG —
       deshalb wird vom Zeichnungs-Element aus im umgebenden Block gesucht. */
    function phasenSchalten(el, p) {
      var host = (el.closest && el.closest('.pz-mech-block')) || el.parentNode || el;
      host.querySelectorAll('.pz-phasen [data-ab]').forEach(function (t) {
        t.classList.toggle('aktiv', p >= parseFloat(t.dataset.ab));
      });
    }
    var fasern = diaFaser ? Array.prototype.slice.call(diaFaser.querySelectorAll('[data-faser]')) : [];
    var PKT = 26, X0 = 40, X1 = 960;
    var knick = fasern.map(function (_, f) {
      var a = [], ph = f * 2.1, mitte = 78 + f * 46;
      for (var i = 0; i < PKT; i++) a.push(mitte + Math.sin(i * 0.72 + ph) * 26 + Math.sin(i * 1.9 + ph) * 12);
      return a;
    });
    var gerade = fasern.map(function (_, f) { return 78 + f * 46; });
    var bruecken = document.getElementById('pz-bruecken');
    var tropfenG = document.getElementById('pz-tropfen');
    var BR = [4, 9, 14, 19, 23];
    if (bruecken && tropfenG) {
      BR.forEach(function () {
        bruecken.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'line'));
      });
      for (var d = 0; d < 7; d++) {
        var c = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        c.setAttribute('r', (2.5 + (d % 3)).toString());
        tropfenG.appendChild(c);
      }
    }
    function faserY(f, i, p) {
      var t = Math.max(0, Math.min(1, (p - 0.28) / 0.5));
      t = t * t * (3 - 2 * t);
      return knick[f][i] + (gerade[f] - knick[f][i]) * t;
    }
    function zeichneFasern(p) {
      fasern.forEach(function (el, f) {
        var d = '';
        for (var i = 0; i < PKT; i++) {
          var x = X0 + i * ((X1 - X0) / (PKT - 1));
          d += (i ? ' L' : 'M') + x.toFixed(1) + ',' + faserY(f, i, p).toFixed(2);
        }
        el.setAttribute('d', d);
      });
      if (!bruecken || !tropfenG) return;
      var offen = p > 0.24 && p < 0.72;
      Array.prototype.forEach.call(bruecken.children, function (l, k) {
        var i = BR[k], x = X0 + i * ((X1 - X0) / (PKT - 1));
        l.setAttribute('x1', x); l.setAttribute('x2', x);
        l.setAttribute('y1', faserY(0, i, p)); l.setAttribute('y2', faserY(1, i, p));
      });
      bruecken.classList.toggle('offen', offen);
      var tp = Math.max(0, Math.min(1, (p - 0.1) / 0.45));
      Array.prototype.forEach.call(tropfenG.children, function (c, k) {
        c.setAttribute('cx', 110 + k * 128);
        c.setAttribute('cy', 20 + tp * (60 + (k % 3) * 22));
        c.setAttribute('opacity', (tp > 0 && tp < 1 ? 0.8 : 0).toString());
      });
    }
    var gerueche = document.getElementById('pz-gerueche');
    var START = [[150, 96], [210, 150], [268, 88], [318, 142]];
    if (gerueche) {
      START.forEach(function (s, k) {
        var c = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        c.setAttribute('r', (9 - k).toString());
        gerueche.appendChild(c);
      });
    }
    function zeichneRing(p) {
      if (!gerueche) return;
      var t = Math.max(0, Math.min(1, (p - 0.2) / 0.6));
      t = t * t * (3 - 2 * t);
      Array.prototype.forEach.call(gerueche.children, function (c, k) {
        var zx = 486 + (k % 2) * 24, zy = 120 + Math.floor(k / 2) * 18;
        c.setAttribute('cx', (START[k][0] + (zx - START[k][0]) * t).toFixed(1));
        c.setAttribute('cy', (START[k][1] + (zy - START[k][1]) * t).toFixed(1));
      });
    }

    /* ---- Zeitachse ---- */
    var road = document.querySelector('[data-pz-road]');
    var roadListe = road ? road.querySelector('.pz-road-list') : null;
    var roadStops = roadListe ? Array.prototype.slice.call(roadListe.querySelectorAll('.pz-road-stop')) : [];
    function zeichneRoad() {
      if (!roadListe) return;
      var r = roadListe.getBoundingClientRect();
      /* Die Hoehe im Bild, auf der die goldene Linie "ankommt". Etwas unterhalb der
         Mitte, damit die naechste Station schon sichtbar ist, bevor sie aufleuchtet. */
      var linie = window.innerHeight * 0.62;
      var p = r.height > 0 ? (linie - r.top) / r.height : 0;
      p = Math.max(0, Math.min(1, p));
      roadListe.style.setProperty('--road', p.toFixed(3));
      roadStops.forEach(function (s) {
        var sr = s.getBoundingClientRect();
        if (sr.top < window.innerHeight * 0.88) s.classList.add('in');
        if (sr.top + 12 < linie) s.classList.add('erreicht');
      });
    }

    /* ---- Seite "Haeufige Fragen" zum Aufklappen umbauen ----
       Der Seiteninhalt in Shopify bleibt unangetastet: dort stehen weiterhin
       schlicht <h2>Frage</h2><p>Antwort</p>. Hier wird daraus im Browser ein
       Akkordeon. Laeuft nur auf der Seite, die die Sektion pazzado-brand-css
       ausdruecklich markiert hat — Rechtstexte werden nie zusammengeklappt. */
    function faqAufklappen() {
      if (document.documentElement.getAttribute('data-pz-faq') !== '1') return;
      var rte = document.querySelector('main .rte');
      if (!rte || rte.dataset.pzUmgebaut) return;
      var fragen = Array.prototype.slice.call(rte.children).filter(function (el) {
        return el.tagName === 'H2' || el.tagName === 'H3';
      });
      if (fragen.length < 2) return;
      rte.dataset.pzUmgebaut = '1';

      var huelle = document.createElement('div');
      huelle.className = 'pz-akkordeon';
      fragen.forEach(function (h, i) {
        var det = document.createElement('details');
        if (i === 0) det.open = true;
        var sum = document.createElement('summary');
        sum.textContent = h.textContent;
        det.appendChild(sum);
        var n = h.nextElementSibling;
        while (n && n.tagName !== 'H2' && n.tagName !== 'H3') {
          var weiter = n.nextElementSibling;
          det.appendChild(n);
          n = weiter;
        }
        huelle.appendChild(det);
        h.remove();
      });
      rte.appendChild(huelle);
    }

    function progress(el) {
      var r = el.getBoundingClientRect();
      var total = r.height - window.innerHeight;
      if (total <= 0) return r.top < window.innerHeight / 2 ? 1 : 0;
      return Math.max(0, Math.min(1, -r.top / total));
    }

    var ticking = false;
    function frame() {
      ticking = false;
      /* crease laeuft in eigener Zeitschleife, nicht mehr hier */
      if (diaFaser) { var pf = sichtFortschritt(diaFaser); zeichneFasern(pf); phasenSchalten(diaFaser, pf); }
      if (diaRing) { var pr = sichtFortschritt(diaRing); zeichneRing(pr); phasenSchalten(diaRing, pr); }
      if (wipe && !manual) {
        var r = wipe.getBoundingClientRect();
        var seen = Math.max(0, Math.min(1, 1 - (r.top / window.innerHeight)));
        setWipe(100 - seen * 88);
      }
      zeichneRoad();
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }

    faqAufklappen();

    if (reduce) {
      drawCrease(1);
      creaseSichtbar = false;
      if (diaFaser) { zeichneFasern(1); phasenSchalten(diaFaser, 1); }
      if (diaRing) { zeichneRing(1); phasenSchalten(diaRing, 1); }
      setWipe(50);
      if (roadListe) {
        roadListe.style.setProperty('--road', '1');
        roadStops.forEach(function (s) { s.classList.add('in', 'erreicht'); });
      }
    } else {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      /* Nach dem Laden nochmals rechnen: Schriften und Bilder verschieben das Layout,
         sonst steht die Zeichnung beim ersten Blick auf dem falschen Stand. */
      window.addEventListener('load', onScroll);
      if (window.visualViewport) window.visualViewport.addEventListener('resize', onScroll);
      drawCrease(0);
      frame();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
